import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook that provides stable credits value to prevent UI flickering
 * when switching browser tabs. Only updates when credits definitively change.
 */
export const useStableCredits = () => {
  const { credits, creditsLoading } = useAuth(); // Get creditsLoading state
  const [stableCredits, setStableCredits] = useState<number | null>(credits); // Allow null
  const hasMountedRef = useRef(false);

  useEffect(() => {
    
    // On initial mount, store the credits value
    if (!hasMountedRef.current) {
      setStableCredits(credits);
      hasMountedRef.current = true;
      return;
    }

    if (!creditsLoading && credits !== null) {
      setStableCredits(credits);
    }
  }, [credits, creditsLoading]); // Add creditsLoading to dependencies

  return stableCredits;
};

export const useBalanceDisplay = () => {
  const { billingMode } = useAuth();
  const balance = useStableCredits();
  if (balance === null) return null;
  if (billingMode === 'credits') return `${Math.floor(balance)} credits`;
  return `$${balance.toFixed(2)}`;
};
